const styles = (theme) => ({
  containerStyle: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: "16 26 8 26",
    backgroundColor: theme.ModalBGColor,
    borderRadius: "4px",
    margin: 4,
    width: "unset",
    border: `1px solid ${theme.AppBGColor}`,
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  confirmButton: {
    fontSize: theme.textFontSize,
    textTransform: "none",
    borderRadius: "2px",

    margin: "10 0 10 5",
    "&$disabledConfirmButton,&$disabledConfirmButton:hover": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8
    },
  },
  disabledConfirmButton: {
    cursor: "not-allowed",
    pointerEvents: "none",
    border: `1px solid ${theme.iconColor}`,
  },
  sectionTitle: {
    fontSize: theme.textFontSize,
    textTransform: "uppercase",
    textAlign: "left",
    color: theme.dispatchPanelHeaderColor,
    letterSpacing: "1.5px",
    marginBottom: 14,
  },
  selectRoot: {
    marginTop: 8,
    marginBottom: 4,
  },
  sectionDisabled: {
    backgroundColor: theme.loaderBgColorTranslucent,
    pointerEvents: "none",
  },
  flexRow: {
    display: "flex",
    position: "relative",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
});

export default styles;
